<script setup lang="ts">
import { MediaImageFragment, ParagraphOpenJobQuote } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphOpenJobQuote
}>()

const image = computed(() => props.entity?.fieldImage?.entity as MediaImageFragment)
const text = computed(() => props.entity?.fieldText?.processed)
const tagline = computed(() => props.entity?.fieldSubline)
</script>

<template>
  <Section v-animate="{ animation: 'vertical-reveal' }" large>
    <div class="background" />
    <div class="image t-10 t-o-1 tl-4">
      <Image v-if="image" :entity="image" type="teaser" />
    </div>
    <div class="text t-10 t-o-1 tl-7 tl-o-0">
      <div v-if="text" class="quote text-xlarge" v-html="text" />
      <h3 v-if="tagline" class="tagline">{{ tagline }}</h3>
    </div>
  </Section>
</template>
<style scoped lang="scss">
.section {
  position: relative;
  @include fluid(padding-top, 64px, 120px);
  @include fluid(padding-bottom, 72px, 128px);
}
.background {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--c-green-dark-100);
  z-index: -1;

  @include fluid(top, 64px, 120px);
  @include breakpoint(t down) {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }
}

.image {
  @include fluid(margin-top, -64px, -120px);

  .dp-image {
    aspect-ratio: 1;
  }
}

.text {
  @include fluid(margin-top, 36px, 96px);
  @include breakpoint(tl) {
    padding: 0 80px 0 40px;
  }
}
.quote {
  margin-bottom: 12px;
  color: var(--c-blue-light-100);
  > :deep(*:last-child) {
    margin-bottom: 0;
  }
}

.tagline {
  font-weight: 400;
  margin-bottom: 0;
  color: var(--c-white);
}
</style>
